export default {
	content_plural: 'Contenidos',
	content: 'Contenido | Contenidos',
	finished: 'Terminado | Terminados',
	how_do_you_rate_this_trail: 'Disponible solo después de que se complete',
	loading_trails: 'Cargando modulos',
	no_trails_are_available_at_the_moment: 'Actualmente no hay modulos disponibles',
	no_trails_are_available_with_the_selected_filter:
		'No hay modulos disponibles para el filtro seleccionado',
	only_available_when_finished_trail: '¿Cómo calificas esta pista?',
}
